<template>
  <div class="profile-box">
    <!-- <div class="profile-title">Basic information</div> -->
    <!-- <div class="profile-avatar-box">
            <img class="my-info-avatar" :src="userInfo.photo?userInfo.photo:defaultAvatar" />
            <el-upload class="upload-demo" :on-preview="handlePreview" :headers="{'x-covey-token':xToken}" :before-upload="beforeImgUpload" :limit="1" :accept="imgRules" :data="{ ts:Date.now()}" :on-exceed="handleAvatarExceed" :on-success="handleImgSuccess" :action="getUploadImg+'?ts='+Date.now()">
                <span style="margin-right:8px;">Upload a new photo</span>
                <img :src="require('@/assets/icon/upload.png')" />
            </el-upload>
        </div> -->

    <div class="item-box" :loading="loading">
      <!-- <template slot="template">
          <el-skeleton-item
            class="item-avatar"
            variant="image"
            style="width: 100%; height: 333px"
          />
          <div class="item-upload margintop24">
            <el-skeleton-item variant="text" style="width: 90%" />
          </div>
          <div class="item-input_48 margintop24">
            <el-skeleton-item variant="text" style="width: 100%" />
          </div>
          <div class="item-input_118 margintop24">
            <el-skeleton-item variant="text" style="width: 100%" />
          </div>
        </template> -->
      <div class="card">
        <div class="item-title">Basic information</div>
        <el-image
          class="item-avatar"
          fit="fill"
          :preview-src-list="[generalInformation.photo]"
          :src="generalInformation.photo"
        >
          <div slot="error" class="image-slot">
            <!-- <i class="el-icon-picture-outline"></i> -->
            <img class="course-teacher-avatar" :src="defaultAvatar" />
          </div>
        </el-image>
        <div class="item-upload margintop24">
          <el-upload
            class="upload-demo"
            :on-preview="handlePreview"
            :headers="{ 'x-covey-token': xToken }"
            :before-upload="beforeImgUpload"
            :accept="imgRules"
            :data="{ ts: Date.now() }"
            :on-exceed="handleAvatarExceed"
            :on-success="handleImgSuccess"
            :action="getUploadImg + '?ts=' + Date.now()"
          >
            <span style="margin-right: 8px">Upload a new photo</span>
            <img :src="require('@/assets/icon/upload.png')" />
          </el-upload>
        </div>
        <el-input
          class="item-input_48 margintop24"
          placeholder="Email"
          v-model="userInfo.email"
        ></el-input>
        <el-select
          class="item-input_48 margintop24"
          v-model="generalInformation.schoolId"
          placeholder="Select your school name"
        >
          <el-option
            v-for="item in schoolList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          class="item-input_118 margintop24"
          type="textarea"
          show-word-limit
          :minlength="200"
          :maxlength="1000"
          :rows="15"
          placeholder="Enter personal profile"
          v-model="generalInformation.desc"
        >
        </el-input>
        <el-button
          class="my-button success-button margintop24"
          @click="preserveGeneralInformation"
          >Preserve</el-button
        >
      </div>
    </div>

    <div class="item-box">
      <div class="card" style="height: 100%">
        <div class="item-title">Real name authentication</div>
        <el-input
          class="item-input_48"
          placeholder="First name"
          v-model="realNameAuthentication.firstname"
        ></el-input>
        <el-input
          class="item-input_48 margintop24"
          placeholder="Last name"
          v-model="realNameAuthentication.lastname"
        ></el-input>
        <el-input
          class="item-input_48 margintop24"
          placeholder="ID Card"
          v-model="realNameAuthentication.photeID"
        ></el-input>
        <el-select
          class="item-input_48 margintop24"
          placeholder="Gender"
          v-model="realNameAuthentication.gender"
        >
          <el-option :value="1" label="male">male</el-option>
          <el-option :value="0" label="female">female</el-option>
        </el-select>
        <el-date-picker
          class="item-input_48 margintop24"
          v-model="realNameAuthentication.birthday"
          type="date"
          placeholder="Date of brith"
        >
        </el-date-picker>
        <el-input
          class="item-input_48 margintop24"
          placeholder="Cell phone"
          v-model="realNameAuthentication.phone"
        >
          <el-select
            v-model="realNameAuthentication.countrycode"
            slot="prepend"
            placeholder="Country Code"
          >
            <el-option
              :label="item.countrycode"
              :value="item.countrycode"
              v-for="(item, index) in CountryCodeList"
              :key="index"
            >
              <span style="float: left">{{ item.countrycode }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.country
              }}</span>
            </el-option>
          </el-select>

          <el-button
            style="
              height: 100%;
              padding-right: 0;
              font-size: 12px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #201002;
            "
            slot="suffix"
            type="text"
            @click="getVerifyCode"
            :loading="verifyLoading"
            >verify</el-button
          >
        </el-input>

        <el-input
          v-if="realNameAuthentication.phone !== userInfo.phone"
          class="item-input_48 margintop24"
          placeholder="Verify the code"
          v-model="realNameAuthentication.code"
        ></el-input>
        <el-input
          class="item-input_118 margintop24"
          type="textarea"
          :rows="4"
          placeholder="Address"
          v-model="realNameAuthentication.address"
        >
        </el-input>
        <div class="item-input_48 margintop24" style="text-align: center">
          <el-button
            class="my-button success-button"
            @click="validateRealNameAuthentication"
            :loading="realNameLoading"
            >Validate</el-button
          >
        </div>
      </div>
    </div>
    <div class="item-box right-box">
      <div class="password card" v-if="userInfo.login_type === 1">
        <div class="item-title">Change Password</div>
        <el-input
          class="item-input_48"
          type="password"
          placeholder="Old password"
          v-model="changePassword.oldPassword"
        ></el-input>
        <el-input
          class="item-input_48 margintop24"
          type="password"
          placeholder="New password"
          v-model="changePassword.newPassword"
        ></el-input>
        <el-input
          class="item-input_48 margintop24"
          type="password"
          placeholder="Repeat new password"
          v-model="changePassword.repeatPassword"
        ></el-input>
        <el-button
          class="my-button success-button margintop24"
          @click="handleChangepassword"
          >Change password</el-button
        >
      </div>
      <div class="card pay">
        <div class="item-title">Method of Payment</div>
        <div class="pay-method">
          <img src="@/assets/icon/paypal.svg" />
          <i
            v-if="!hasPaypal"
            class="el-icon-circle-plus-outline"
            @click="addPaypal"
          ></i>
          <i v-if="hasPaypal" class="el-icon-edit" @click="editPaypal"></i>
        </div>
        <el-select
          class="item-input_48 margintop24"
          v-if="opPaypal"
          v-model="paymentForm.recipient_type"
          placeholder="Account Type"
        >
          <el-option label="EMAIL" value="EMAIL"></el-option>
          <el-option label="PHONE" value="PHONE"></el-option>
        </el-select>
        <div
          v-if="hasPaypal && !opPaypal"
          class="item-input_48 margintop24 pay-no"
          style="text-align: left"
        >
          <span>No: {{ paymentForm.payNO }}</span>
        </div>
        <el-input
          class="item-input_118 margintop24 pay-no"
          v-if="opPaypal"
          v-model="paymentForm.payNO"
          type="textarea"
          placeholder="Paypal account"
          :row="6"
        >
        </el-input>
        <div v-if="opPaypal" style="text-align: center">
          <el-button
            class="my-button success-button margintop24"
            @click="handleConfirmPay"
            >Confirm</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MD5, scopeDomain, CountryCodeList } from "@/utils/comm";
import Cookies from "js-cookie";
import { isEmail } from "@/utils/validate";
import ValidateButton from "@/views/Pc/Component/ValidateButton";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    //   todo  验证手机号 字段传code
    ValidateButton,
  },
  created() {
    this.$store.dispatch("REFRESH_USER_INFO");
  },
  watch: {
    userInfo: function (newval, oldVal) {
      this.initUserinfo();
    },
  },
  computed: {
    ...mapState({
      xToken: (state) => state.app.token,
      userInfo: (state) => state.app.userInfo,
      defaultAvatar: (state) => state.app.defaultAvatar,
    }),
    ...mapGetters(["getUploadImg"]),
  },
  mounted() {
    this.$nextTick(() => {
      this.initUserinfo();
    });
    this.getSchoolList();
    this.getPaypal();
  },
  data() {
    return {
      loading: true,
      CountryCodeList: CountryCodeList,
      personalProfile: "",
      value1: "",
      Address: "",
      imgRules: "image/png , image/jpeg",
      //头像等
      generalInformation: {
        photo: "",
        desc: "",
        schoolId: "",
      },
      realNameAuthentication: {
        firstname: "",
        lastname: "",
        photeID: "",
        gender: "",
        birthday: "",
        phone: "",
        address: "",
        code: "",
        countrycode: "",
      },
      changePassword: {
        oldPassword: "",
        newPassword: "",
        repeatPassword: "",
      },
      realNameLoading: false, //更新RealName等待
      userType: "",
      //支付paypal
      paymentForm: {
        payNO: "",
        recipient_type: "",
        id: "",
      },
      hasPaypal: false, //add或者update
      opPaypal: "", //add或者update
      verifyLoading: false,
      schoolList: [], //待选择的学校
    };
  },
  methods: {
    initUserinfo() {
      this.generalInformation.photo = this.userInfo.photo;
      this.generalInformation.schoolId = this.userInfo.schoolId;

      if (this.$route.path.includes("/myinfo")) {
        this.generalInformation.desc = this.userInfo.desc || "";
      } else if (this.$route.path.includes("/teacherInfo")) {
        this.generalInformation.desc = this.userInfo.teacherdesc || "";
      }

      this.realNameAuthentication = {
        firstname: this.userInfo.firstname,
        lastname: this.userInfo.lastname,
        photeID: this.userInfo.photeID,
        gender: this.userInfo.gender,
        birthday: this.userInfo.birthday,
        phone: this.userInfo.phone,
        address: this.userInfo.address,
        countrycode: this.userInfo.countrycode,
        code: "",
      };
      this.loading = false;
    },
    handleAvatarExceed() {
      this.$message.error("Up to a photo can be uploaded.");
    },
    handlePreview() {},

    //上传文件检查
    beforeImgUpload(file) {
      const isImage = this.imgRules.includes(file.type);
      const isLt20M = file.size / 1024 / 1024 <= 5;
      if (!isImage) {
        this.$message.error(
          "Only upload pictures in PNG/JPG format is supported."
        );
        return isImage && isLt20M;
      }
      if (!isLt20M) {
        this.$message.error("Upload picture size cannot exceed 5MB.");
        return isImage && isLt20M;
      }
      return isImage && isLt20M;
    },
    handleImgSuccess(res, file, fileList) {
      if (res.status === "0") {
        this.$message.success("SUCCESS!");
        this.generalInformation.photo = res.data;
      } else {
        this.$message.error(`${file.name} ERROR! Reason : ${res.message}`);
      }
      this.loadingImg = false;
    },
    preserveGeneralInformation() {
      let params = { ...this.generalInformation };
      params["email"] = this.userInfo.email;
      if (!params.photo) {
        this.$message.warning("Please upload a photo");
        return;
      }
      if (
        !params.desc ||
        params.desc.length < 200 ||
        params.desc.length > 1000
      ) {
        this.$message.warning(
          "The content length of this description is between 200 and 1000"
        );
        return;
      }
      if (!params.email) {
        this.$message.warning("Please fill in your email");
        return;
      }
      if (this.$route.path.includes("/teacherInfo")) {
        //如果是老师 ，传teacherdesc
        params["teacherdesc"] = params.desc;
        delete params.desc;
      }
      this.$api.userApi.updateGeneralInfo(params).then((res) => {
        //更新个人信息之后要重新接收 信息
        if (res.status === "0") {
          this.getUserInfoFn();
          this.$message.success("SUCCESS!");
        } else {
          this.$message.error(`ERROR! Reason : ${res.message}`);
        }
      });
    },
    //更新详细信息
    validateRealNameAuthentication() {
      let params = { ...this.realNameAuthentication };
      let hasPhone = false;
      if (params.phone && params.phone !== this.userInfo.phone) {
        hasPhone = true; //修改了手机号 则需要code
        if (!params.code) {
          this.$message.warning("Please fill in the check code!");
          return;
        }
      } else {
        //未修改或者手机号为空
        delete params.code;
      }
      if (!this.$paramsValidate(params)) {
        this.$message.warning(
          "Please fill in the real-name authentication information completely!"
        );
        return;
      }
      for (let key in params) {
        if (key === "countrycode" && hasPhone) {
          continue;
        } else if (params[key] === this.userInfo[key]) {
          delete params[key];
        }
      }
      if (JSON.stringify(params) === JSON.stringify({})) {
        this.$message.warning("No changes!");
        return;
      }
      this.realNameLoading = true;
      this.$api.userApi.updateRealNameAuth(params).then((res) => {
        if (res.status === "0") {
          this.getUserInfoFn();
          this.$message.success("SUCCESS!");
          this.$store.dispatch("REFRESH_USER_INFO");
        } else {
          this.$message.error(`ERROR! Reason : ${res.message}`);
        }
        this.realNameLoading = false;
      });
    },
    //获取用户信息
    async getUserInfoFn() {
      this.loading = true;
      const { status, data, message } = await this.$api.comApi.getUserInfo();
      if (status === "0") {
        this.$store.commit("handleUserInfo", data || {});
        this.$store.commit("SET_USERINFO", data || {});
      }
      this.loading = false;
    },
    //修改密码
    handleChangepassword() {
      let params = { ...this.changePassword };

      if (params.repeatPassword !== params.newPassword) {
        this.$message.error(
          "The duplicate password is inconsistent with the new password."
        );
        return;
      }
      //todo 调试
      delete params.repeatPassword;
      params.oldPassword = MD5(params.oldPassword);
      params.newPassword = MD5(params.newPassword);
      this.$api.userApi.updatePassword(params).then((res) => {
        if (res.status === "0") {
          this.$message.success("SUCCESS!");
          Cookies.remove(scopeDomain.name, { domain: scopeDomain.path });
          this.$store.commit("clearUserInfo");
          this.$store.commit("menuRouteLoaded", false);
          this.$store.commit("SET_LOGIN_DIALOG", true);
          this.$router.push({ path: "/" });
        } else {
          this.$message.error(`ERROR! Reason : ${res.message}`);
        }
      });
    },
    //获取支付账户
    getPaypal() {
      this.$api.comApi.getBankList().then((res) => {
        if (res.status === "0") {
          this.opPaypal = "";
          if (res.data.rows.length > 0) {
            this.hasPaypal = true;
            this.paymentForm.payNO = res.data.rows[0].payNO || "";
            this.paymentForm.id = res.data.rows[0].id || "";
            this.paymentForm.recipient_type =
              res.data.rows[0].recipient_type || "";
          }
        }
      });
    },
    addPaypal() {
      this.opPaypal = this.opPaypal === "add" ? "" : "add";
    },
    editPaypal() {
      this.opPaypal = this.opPaypal === "update" ? "" : "update";
    },
    handleConfirmPay() {
      let params = { ...this.paymentForm };
      if (!params.recipient_type) {
        this.$message.warning("Please select your account type!");
        return;
      }
      if (!params.payNO) {
        this.$message.warning("Please fill in your Paypal no!");
        return;
      }
      if (this.opPaypal === "add") {
        delete params.id;
        this.$api.comApi.addBank(params).then((res) => {
          if (res.status === "0") {
            this.$message.success(res.message);
            this.getPaypal();
          } else {
            this.$message.error(res.message);
          }
        });
        return;
      }
      if (this.opPaypal === "update") {
        this.$api.comApi.updateBank(params).then((res) => {
          if (res.status === "0") {
            this.$message.success(res.message);
            this.getPaypal();
          } else {
            this.$message.error(res.message);
          }
        });
        return;
      }
    },

    async getVerifyCode() {
      if (!this.realNameAuthentication.phone) {
        this.$message.error("Please fill in your mobile phone number.");
        return;
      }
      if (!this.realNameAuthentication.countrycode) {
        this.$message.error("Please select your mobile phone country.");
        return;
      }
      this.verifyLoading = true;
      this.$api.userApi
        .sendSms({
          phone:
            this.realNameAuthentication.countrycode +
            this.realNameAuthentication.phone,
        })
        .then((res) => {
          this.$message({
            type: res.status === "0" ? "success" : "error",
            message: res.message,
          });
          this.verifyLoading = false;
        })
        .catch((err) => {
          this.verifyLoading = false;
          this.$message.error(`SYSTEM ERROR!`);
        });
    },

    //获取学校下拉列表
    getSchoolList() {
      this.$api.courseApi.getSchoolList().then((res) => {
        if (res.status === "0") {
          this.schoolList = res.data.rows;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.profile-box {
  height: 100%;
  display: flex;
  column-count: 3;
  column-gap: 16px;
  box-sizing: border-box;
  font-family: PingFangSC-Medium, PingFang SC;
  // background: #fff;
  // box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  // border-radius: 8px;
  /deep/.el-textarea__inner {
    font-family: "PingFangSC-Semibold", "PingFang SC";
    height: 100%;
  }
  /deep/.el-input-group__prepend {
    width: 46px;
  }
  .item-box {
    width: 0;
    flex: 1;
    .card {
      position: relative;
      padding: 32px;
      background: #fff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
      border-radius: 8px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      .item-title {
        font-size: 14px;
        font-weight: 600;
        color: #201002;
        line-height: 20px;
        margin-bottom: 32px;
      }
    }
  }
  .right-box {
    display: flex;
    flex-direction: column;
    .pay {
      height: 100%;
    }
  }
  .profile-title {
    height: 25px;
    font-size: 18px;
    font-weight: normal;
    color: #181d2c;
    line-height: 25px;
  }
  .profile-avatar-box {
    margin-top: 24px;
    .my-info-avatar {
      width: 96px;
      height: 96px;
      border-radius: 50%;
    }
    .upload-demo {
      margin-left: 16px;
      display: inline;
      font-size: 15px;
      height: 20px;
      font-weight: 500;
      color: #f48c06;
      line-height: 20px;
      img {
        vertical-align: top;
      }
    }
  }
  .my-button {
    width: auto;
    cursor: pointer;
    padding: 0 40px;
    height: 48px;
    background: #b7b2ae;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    pointer-events: none;
    border: none;
    span {
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }
  }
  .success-button {
    border: none;
    color: #ffffff;
    background: #f48c06;
    pointer-events: auto !important;
  }
  .item-avatar {
    margin: 0 auto;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    .course-teacher-avatar {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .item-upload {
    font-size: 14px;
    color: #f48c06;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 14px;
      color: #f48c06;
    }
    img {
      width: 16px;
      height: 16px;
    }
  }
  .password {
    margin-bottom: 32px;
  }
  .pay-no {
    word-break: break-all;
    line-height: 24px;
    font-weight: 500;
  }
  .pay-method {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 16px;
    background: rgba(32, 16, 2, 0.04);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    img {
      width: auto;
      height: 40px;
    }
    // i {
    //   float: right;
    // }
    .el-input {
      /deep/.el-input-group__prepend {
        width: 52px;
        background: #fff;
      }
    }
  }

  .item-input_48 {
    width: 100%;
    height: 48px;
    /deep/.el-input__inner {
      height: 48px;
      line-height: 48px;
    }
  }
  .margintop24 {
    margin-top: vw(24);
  }
  .margintop32 {
    margin-top: vw(32);
  }
  .item-input_118 {
    height: 100%;
  }
}
</style>